import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { getImageUrl, trackEvent } from "../Utility/Utility";
import { getProductList } from "../../Store/Slices/productSlice";
import Loader from "../Loader/Loader";
import { decryptURLParam } from "../../Common/Axios/encrypt";

const TNCPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [data, setData] = useState();
  const translation = getTranslationData();
  const [isLoading, setIsLoading] = useState(true);
  // const productData = useSelector(
  //   (state) => state.productReducer.productById?.[0]?.products
  // );
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encryptedProductId = params.get("productId"); // Get encrypted productId from the query params
    const productId = encryptedProductId
      ? decryptURLParam(encryptedProductId)
      : null; // Decrypt it
    const payload = {
      productId: productId,
      pageNumber: 1,
      pageSize: 10,
    };
    dispatch(getProductList(payload))
      .then((res) => {
        if (res?.payload?.response?.products) {
          let product = res?.payload.response.products.find(
            (prod) => prod.id === parseInt(productId)
          );
          setData(product);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const productId = params.get("productId"); // Get productId from the query params

  //   if (productId) {
  //     const selectedProduct = productData?.find(
  //       (item) => item.id === parseInt(productId)
  //     );
  //     setData(selectedProduct);
  //   }
  // }, [location.search, productData]);
  useEffect(() => {
    trackEvent("page_browse", {

      page_title: "TNC page",
      page_url: window.location.href,

    });
  }, []);
  return (
    <>
      {isLoading ? <Loader /> : null}
      <section className="tnc-widget tnc-bg-white">
        <div className="tnc-container">
          <div className="tnc-justify-content-center tnc-img-alignment">
            <img
              src={getImageUrl(data?.small)}
              id="ctl00_ContentPlaceHolder1_brandlogo"
              alt={data?.name}
            />
          </div>
          <div className="tnc-row">
            <div className="tnc-col-sm-12">
              <div className="tnc-product-details-head">
                <div className="tnc-container">
                  <div className="tnc-row tnc-align-items-center">
                    <div className="tnc-col-sm-12 tnc-col-md-4 tnc-col-lg-3 tnc-text-center"></div>
                    <div className="tnc-col-sm-8 tnc-col-md-7 tnc-col-lg-6">
                      <div className="tnc-row w-100 d-flex justify-content-center">
                        <div className="tnc-col-sm-12 col-md-6 hideOnMobile">
                          <div>
                            <p className="text-start tnc_para">
                              {data?.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tnc-row tnc-mt-4">
            {data?.instructionsContent?.trim() && (
              <div className="tnc-col-sm-12">
                <h2 className="tnc-opiis">
                  {translation?.importantInstructions}
                </h2>
                <div
                  className="pd-left list-bullet"
                  dangerouslySetInnerHTML={{ __html: data.instructionsContent }}
                ></div>
              </div>
            )}
            {data?.howToUseContent?.trim() && (
              <div className="tnc-col-sm-12">
                <h2 className="tnc-opiis">{translation?.how_to_use}</h2>
                <div
                  className="pd-left list-bullet"
                  dangerouslySetInnerHTML={{ __html: data.howToUseContent }}
                ></div>
              </div>
            )}
            {data?.tncContent?.trim() && (
              <div className="tnc-col-sm-12">
                <h2 className="tnc-opiis">{translation?.terms_condition}</h2>
                <div
                  className="pd-left list-bullet"
                  dangerouslySetInnerHTML={{ __html: data.tncContent }}
                ></div>
              </div>
            )}
          </div>

          {/* <div className="tnc-row tnc-mt-4">
                        <div className="tnc-col-sm-12">
                            <h2 className="tnc-opiis">How to Redeem</h2>
                            <p>Walk into a Kalyan store</p>
                            <p>Select the applicable Kalyan product</p>
                            <p>At the billing counter, inform the cashier about the choice of making payment using Gift Cards.</p>
                            <p>The cashier selects Gift Card as the payment mode, submits card details in the system, and completes the billing process.</p>
                        </div>
                    </div> */}
        </div>
      </section>
    </>
  );
};

export default TNCPage;
